import DatabaseModel from './DatabaseModel.js';

var TipoTarea = Object.create(DatabaseModel);

TipoTarea.model = 'tipotarea';
TipoTarea.modelFront = 'tipostarea';

export default TipoTarea;